export const zakladki = {
    "zakladki": {
      "@ile": "7",
      "items": [
        {
          "@ile": "1",
          "item": [
            {
              "nazwa": "Wycieczki",
              "pozycja": "1-A",
              "link": "/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Last Minute",
              "pozycja": "1-B",
              "link": "/oferta/szukaj.xml?extern=1&lm=1",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Bez paszportu",
              "pozycja": "1-C",
              "link": "/oferta/szukaj.xml?extern=1&sort=0&dojazd=samolot&pobyt=6,15&adt=2&udog=800000000&udor=1",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Dojazd wlasny",
              "pozycja": "1-D",
              "link": "/oferta/szukaj.xml?extern=1&dojazd=wlasny",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "All Inclusive",
              "pozycja": "1-E",
              "link": "/oferta/szukaj.xml?extern=1&wyz=AI",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Lato 2025",
              "pozycja": "1-F",
              "link": "/oferta/szukaj.xml?extern=1&sort=0&dojazd=samolot&pobyt=6,15&adt=2&termin=2025-06-01&terminDo=2025-10-01",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Sylwester",
              "pozycja": "1-G",
              "link": "/oferta/szukaj.xml?extern=1&sort=0&dojazd=samolot&pobyt=6,15&adt=2&termin=2025-12-24&dni=7",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Egzotyka",
              "pozycja": "1-H",
              "link": "www.egzotyka.travelone.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Wycieczki objazdowe",
              "pozycja": "1-I",
              "link": "www.wycieczki.travelone.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Więcej",
              "pozycja": "1-J",
              "link": "/rodzaj-oferty.xml",
              "geourl": [],
              "target": [],
              "follow": []
            }
          ]
        },
        {
          "@ile": "2",
          "item": [
            {
              "nazwa": "Last Minute",
              "pozycja": "2-A",
              "link": "/oferta/szukaj.xml?extern=1&lm=1",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Chorwacja",
              "pozycja": "2-B",
              "link": "/oferta/szukaj.xml?extern=1&lm=1&panstwo=HR&adt=2&pobyt=6,15",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Grecja",
              "pozycja": "2-C",
              "link": "/oferta/szukaj.xml?extern=1&dojazd=samolot&lm=1&panstwo=GR&adt=2&pobyt=6,15",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Turcja",
              "pozycja": "2-D",
              "link": "/oferta/szukaj.xml?extern=1&dojazd=samolot&lm=1&panstwo=TK&adt=2&pobyt=6,15",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Majorka",
              "pozycja": "2-E",
              "link": "/oferta/szukaj.xml?extern=1&dojazd=samolot&lm=1&panstwo=BA&adt=2&pobyt=6,15",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Hiszpania",
              "pozycja": "2-F",
              "link": "/oferta/szukaj.xml?extern=1&dojazd=samolot&lm=1&panstwo=ES&adt=2&pobyt=6,15",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Wyspy Kanaryjskie",
              "pozycja": "2-G",
              "link": "/oferta/szukaj.xml?extern=1&dojazd=samolot&lm=1&panstwo=CI&adt=2&pobyt=6,15",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Portugalia",
              "pozycja": "2-H",
              "link": "/oferta/szukaj.xml?extern=1&dojazd=samolot&lm=1&panstwo=PT&adt=2&pobyt=6,15",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Włochy",
              "pozycja": "2-I",
              "link": "/oferta/szukaj.xml?extern=1&lm=1&panstwo=IT&adt=2&pobyt=6,15",
              "geourl": [],
              "target": [],
              "follow": []
            }
          ]
        },
        {
          "@ile": "3",
          "item": [
            {
              "nazwa": "Lato 2025",
              "pozycja": "3-A",
              "link": "/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Turcja",
              "pozycja": "3-B",
              "link": "www.turcja.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Egipt",
              "pozycja": "3-C",
              "link": "www.egipt.info.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Hiszpania",
              "pozycja": "3-D",
              "link": "www.hiszpania.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "EGZOTYKA:",
              "pozycja": "3-E",
              "link": "www.egzotyka.travelone.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Kenia",
              "pozycja": "3-F",
              "link": "www.kenia.info.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Karaiby",
              "pozycja": "3-G",
              "link": "www.karaiby.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Tajlandia",
              "pozycja": "3-H",
              "link": "www.tajlandia.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Malediwy",
              "pozycja": "3-I",
              "link": "www.malediwy.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Sri Lanka",
              "pozycja": "3-J",
              "link": "www.srilanka.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Indie",
              "pozycja": "3-K",
              "link": "www.indie.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Seszele",
              "pozycja": "3-L",
              "link": "www.seszele.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Mauritius",
              "pozycja": "3-M",
              "link": "www.mauritius.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            }
          ]
        },
        /*{
          "@ile": "5",
          "item": [
            {
              "nazwa": "Hotele",
              "pozycja": "5-A",
              "link": "www.hotelone.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Czechy",
              "pozycja": "5-B",
              "link": "www.hotele.czechy.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Francja",
              "pozycja": "5-C",
              "link": "www.hotele.francja.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Hiszpania",
              "pozycja": "5-D",
              "link": "www.hotele.hiszpania.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Włochy",
              "pozycja": "5-E",
              "link": "www.hotele.wlochy.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Portugalia",
              "pozycja": "5-F",
              "link": "www.hotele.portugalia.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Wielka Brytania",
              "pozycja": "5-G",
              "link": "www.hotele.wielkabrytania.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Stany Zjednoczone",
              "pozycja": "5-H",
              "link": "www.hotele.stanyzjednoczone.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            }
          ]
        },
        {
          "@ile": "6",
          "item": [
            {
              "nazwa": "Domy wakacyjne",
              "pozycja": "6-A",
              "link": "www.domy-wakacyjne.travelone.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Austria",
              "pozycja": "6-B",
              "link": "www.domy-wakacyjne.austria.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Włochy",
              "pozycja": "6-C",
              "link": "www.domy-wakacyjne.wlochy.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Szwajcaria",
              "pozycja": "6-D",
              "link": "www.domy-wakacyjne.szwajcaria.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Chorwacja",
              "pozycja": "6-E",
              "link": "www.domy-wakacyjne.chorwacja.pl/?language=pl",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Hiszpania",
              "pozycja": "6-F",
              "link": "www.domy-wakacyjne.hiszpania.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Francja",
              "pozycja": "6-G",
              "link": "www.domy-wakacyjne.francja.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Portugalia",
              "pozycja": "6-H",
              "link": "www.domy-wakacyjne.portugalia.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Węgry",
              "pozycja": "6-I",
              "link": "www.domy-wakacyjne.wegry.biz.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Bułgaria",
              "pozycja": "6-J",
              "link": "www.domy-wakacyjne.bulgaria.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            }
          ]
        }*/
      ]
  }
}
